import React from 'react';
import { LuArrowLeft, LuChevronRight } from 'react-icons/lu';
import { Link, Navigate, useParams } from 'react-router-dom';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { Title } from 'widgets';

import { TenantReportingSettingsPage } from '../reporting-settings/TenantReportingSettingsPage';
import { NoteTemplatesAdmin } from './notetemplate/NoteTemplatesAdmin';
import { NotificationPreferences } from './notifications/NotificationPreferences';
import { KeywordSegmentation } from './segmentation';
import { UserPreferences } from './user-preferences/UserPreferences';

export const Preferences = () => (
    <ErrorBoundary>
        <PreferencesInternal />
    </ErrorBoundary>
);

const PreferencesInternal = () => {
    const { tab } = useParams();
    const pages = [
        {
            title: 'Note Templates',
            url: '/note-templates',
            Component: <NoteTemplatesAdmin />,
        },
        {
            title: 'Keyword Segmentation',
            url: '/keyword-segmentation',
            Component: <KeywordSegmentation />,
        },
        {
            title: 'Notifications',
            url: '/notifications',
            Component: <NotificationPreferences />,
        },
        {
            title: 'Reporting Settings',
            url: '/reporting-settings',
            Component: <TenantReportingSettingsPage />,
        },
        {
            title: 'Claire™',
            url: '/claire',
            Component: <UserPreferences />,
        },
    ];
    const activePage = pages.find((page) => page.url === `/${tab}`);

    if (!activePage) {
        return <Navigate to="/preferences" replace />;
    }

    return (
        <div className="flex w-full min-w-0 flex-col overflow-hidden bg-white">
            <header className="font-heading mt-2 flex min-w-0 items-center gap-3 px-8 py-4">
                <Link
                    className="text-muted-foreground hover:text-foreground focus:ring-ring inline-flex shrink-0 items-center gap-1.5 rounded-sm text-sm font-medium transition focus:ring-2 focus:outline-none"
                    to="/preferences"
                >
                    <LuArrowLeft className="size-4" />
                    <Title page $truncated className="text-2xl">
                        Preferences
                    </Title>
                </Link>
                <LuChevronRight className="text-muted-foreground size-4 shrink-0" />
                <Title page $truncated className="text-2xl">
                    {activePage.title}
                </Title>
            </header>
            <ErrorBoundary>
                <div className="min-w-0 flex-1 overflow-y-auto pt-6 pr-6 pb-16 pl-8">{activePage.Component}</div>
            </ErrorBoundary>
        </div>
    );
};
